import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileBrowserComponent } from './components/file-browser/file-browser.component';
import { FileBrowserFileComponent } from './components/file-browser-file/file-browser-file.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FileBrowserStorageComponent } from './components/file-browser-storage/file-browser-storage.component';
import { FileBrowserNewFolderComponent } from './modals/file-browser-new-folder/file-browser-new-folder.component';
import { NbContextMenuModule, NbMenuModule, NbPopoverModule } from '@nebular/theme';
import { FileBrowserListSwitchComponent } from './components/file-browser-list-switch/file-browser-list-switch.component';
import { FileBrowserSortComponent } from './components/file-browser-sort/file-browser-sort.component';
import { SharedModule } from '@shared/shared.module';
import { AccountSharedModule } from '../account/account-shared.module';
import { AccessModule } from '@access/access.module';

@NgModule({
  declarations: [
    FileBrowserComponent,
    FileBrowserFileComponent,
    FileBrowserStorageComponent,
    FileBrowserNewFolderComponent,
    FileBrowserListSwitchComponent,
    FileBrowserSortComponent
  ],
  exports: [
    FileBrowserComponent,
    FileBrowserStorageComponent,
    FileBrowserListSwitchComponent,
    FileBrowserSortComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
    AccountSharedModule,
    NbContextMenuModule,
    NbPopoverModule,
    AccessModule
  ]
})
export class FileBrowserModule { }
